import { useState } from "react";

import { unescape } from "@/components/helpers/string-utils";
import { NoteEditable } from "@/components/pieces/note/NoteEditable";
import { ClientNotesQueryDocument, useSaveClientNoteMutation } from "@/graphql";
import { CustomerUser } from "@/types/users";

interface ClientNoteEditableProps {
  user: CustomerUser;
  note: {
    id: string;
    content?: string | null;
  };
  onSaveCompleted: () => void;
  onCancel: () => void;
}

export function ClientNoteEditable({
  user,
  note,
  onSaveCompleted,
  onCancel,
}: ClientNoteEditableProps) {
  const [value, setValue] = useState(note.content || "");

  const [saveNote, { loading }] = useSaveClientNoteMutation({
    variables: {
      noteId: note.id,
      customerId: user.id,
      noteContent: unescape(value.trim()),
    },
    refetchQueries: [
      {
        query: ClientNotesQueryDocument,
        variables: {
          customerId: user.id,
        },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: () => {
      if (onSaveCompleted) {
        onSaveCompleted();
      }
    },
  });

  const onSave = () => {
    if (value.trim()) {
      saveNote();
    }
  };

  return (
    <NoteEditable
      isNew={!note.id}
      value={value}
      loading={loading}
      onSave={onSave}
      onCancel={onCancel}
      onChange={setValue}
    />
  );
}
